import React from 'react';
import * as S from './AccountPanel.styles';

import { SubPanel } from '../components/SubPanel/SubPanel';
import { useAccountPanelPresenter } from './AccountPanel.presenter';
import { InformationBlock } from '../components/InformationBlock/InformationBlock';
import { VOID_FUNCTION } from 'constants/index';

export const AccountPanel = ({ onClose = VOID_FUNCTION }) => {
  const presenter = useAccountPanelPresenter();

  return (
    <SubPanel title="Контакты вашего менеджера" dataTest="accountMenu" onClose={onClose}>
      <S.Group>
        <InformationBlock info={presenter.accountInfo} dataTest="account" />
        <InformationBlock info={presenter.supportInfo} dataTest="support" />
      </S.Group>
    </SubPanel>
  );
};
